import React from 'react';
import clsx from 'clsx';
import { EmptyState } from '../emptyState';
import { Spinner } from '../spinner';
import { Answer, ComplaintDocument, UserComplaint } from '@/interfaces';
export interface DemandTableProps {
	tableData?: ComplaintDocument;
}

export interface AnwserColumnsProps {
	row: UserComplaint;
}

export const AnwserColumns: React.FC<AnwserColumnsProps> = ({ row }) => {
	const getAnswersById = (answers: Answer[], questionId: number): string => {
		const answer = answers.find((item) => item.question_id === questionId);
		return answer ? answer.content : ''; // Devuelve el contenido si se encuentra, de lo contrario, una cadena vacía
	};

	const [showMore, setShowMore] = React.useState(false);

	const toggleShowMore = (): void => {
		setShowMore(!showMore);
	};

	return (
		<>
			{row.answers?.map((item) => {
				const content =
					(row.answers && getAnswersById(row.answers, item.question_id)) || '';
				const isShowMore = content?.length > 220;
				return (
					<td key={'anwser' + item.question_id} className="px-6 py-4">
						<p
							className={clsx({
								'max-h-[140px] overflow-hidden': isShowMore && !showMore,
							})}
						>
							{content}
						</p>
						{isShowMore && (
							<button
								type="button"
								className="text-primary font-semibold underline hover:opacity-60"
								onClick={toggleShowMore}
							>
								{showMore ? 'show less' : 'show more'}
							</button>
						)}
					</td>
				);
			})}
		</>
	);
};
export const DemandTable: React.FC<DemandTableProps> = ({ tableData }) => {
	const allQuestions = tableData?.users.flatMap((item) => item.questions);
	const uniqueQuestions = Array.from(
		new Map(allQuestions?.map((question) => [question?.id, question])).values() // Remove questions repeated
	);
	return (
		<>
			{tableData ? (
				tableData.users.length > 0 ? (
					<div
						className={`rounded-lg border border-dark-10 border-none shadow-none overflow-x-auto scroll-custom`}
					>
						{/* Table Container */}
						<table className="w-full text-sm text-left">
							{/* Header columns */}
							<thead className="text-sm text-black capitalize bg-gray-50 font-bold">
								<tr>
									<th
										scope="col"
										className="px-6 py-3 font-semibold lg:min-w-[100px] lg:max-w-[150px]"
									>
										Name
									</th>
									<th
										scope="col"
										className="px-6 py-3 font-semibold lg:min-w-[100px] lg:max-w-[150px]"
									>
										State
									</th>
									<th
										colSpan={6}
										scope="col"
										className="px-6 py-3 font-semibold"
									>
										All Questions from Claim Form
									</th>
								</tr>
								<tr>
									<th></th>
									<th></th>
									{uniqueQuestions?.map((question) => (
										<th
											key={'question-' + question?.id}
											scope="col"
											className="px-6 py-3 font-semibold lg:min-w-[200px] lg:max-w-[250px]"
										>
											{question?.content}
										</th>
									))}
								</tr>
							</thead>

							{/* Content Rows */}
							<tbody>
								{tableData.users.map((row, index) => {
									return (
										<tr
											key={`table-row-${index}`}
											className={clsx('bg-white border-t border-dark-10')}
										>
											<td className="px-6 py-4">
												{row.first_name + ' ' + row.last_name}
											</td>
											<td className="px-6 py-4">{row.state}</td>
											<AnwserColumns row={row} />
										</tr>
									);
								})}
							</tbody>
						</table>
					</div>
				) : (
					<EmptyState />
				)
			) : (
				<div className="w-full h-full flex justify-center items-center">
					<Spinner type="loadingPage" />
				</div>
			)}
		</>
	);
};

export default DemandTable;
